import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Loading from './components/@common/Loding/Loding';
import GlobalStyles from './styles/global';
import router from './routes';
import theme from './styles/theme';
import { RecoilRoot } from 'recoil';
import Modal from './components/@common/CommonModal';

function App() {
  return (
    <RecoilRoot>
      <Suspense fallback={<Loading />}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <RouterProvider router={router} />
          <Modal />
        </ThemeProvider>
      </Suspense>
    </RecoilRoot>
  );
}

export default App;
